import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { HotelI18n_DesignPage_Query } from "./query";

type Props = {
	hotelID: string;
	langCode: LangCode;
};

export const useHotelI18nArticleQuery = ({ hotelID, langCode }: Props) => {
	const { data } = useCustomSuspenseQuery(HotelI18n_DesignPage_Query, {
		variables: { hotelID, lang: langCode },
	});

	return {
		data,
	};
};
